export default class PictureTextGridTile {
    readonly position: number;
    readonly subline: string;

    constructor(tileDom: Element, position: number) {
        this.subline = tileDom.querySelector("oc-promo-card-v1[footer-headline]")?.getAttribute("footer-headline") || "";
        this.position = position;
        tileDom.setAttribute("data-tile-position", position.toString())
    }
}